(function () {
  const cookieConsentScriptUrl = "https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.1/cookieconsent.min.js";
  const defaultLanguage = "en";

  const contentByLanguage = {
    en: {
      message: "This website uses cookies to improve your experience.",
      deny: "Reject",
      allow: "Accept",
      link: "Learn more",
      policy: "🍪",
      revokeTitle: "Cookie settings",
    },
    es: {
      message: "Este sitio utiliza cookies para mejorar su experiencia.",
      deny: "Rechazar",
      allow: "Aceptar",
      link: "Más información",
      policy: "🍪",
      revokeTitle: "Configuración de cookies",
    },
    pt: {
      message: "Este site utiliza cookies para melhorar a sua experiência.",
      deny: "Recusar",
      allow: "Aceitar",
      link: "Saiba mais",
      policy: "🍪",
      revokeTitle: "Configurações de cookies",
    },
  };

  function getUrlParameter(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function getCookieConsentLanguage() {
    const forcedLocale = getUrlParameter("defaultLocale");
    const force = getUrlParameter("force");

    if (
      forcedLocale &&
      force &&
      force.toLowerCase() === "true" &&
      contentByLanguage[forcedLocale.toLowerCase()]
    ) {
      return forcedLocale.toLowerCase();
    }

    const browserLanguage = (navigator.language || navigator.userLanguage || "")
      .slice(0, 2)
      .toLowerCase();

    if (contentByLanguage[browserLanguage]) {
      return browserLanguage;
    }

    return defaultLanguage;
  }

  function updateRevokeButton(content) {
    const revokeButton = document.querySelector(".cc-revoke");
    if (!revokeButton) {
      return;
    }

    revokeButton.textContent = content.policy;
    revokeButton.setAttribute("aria-label", content.revokeTitle);
    revokeButton.setAttribute("title", content.revokeTitle);
  }

  function initialiseCookieConsent() {
    if (window.__paddCookieConsentInitialised || !window.cookieconsent) {
      return;
    }

    window.__paddCookieConsentInitialised = true;
    const language = getCookieConsentLanguage();
    const content = contentByLanguage[language] || contentByLanguage[defaultLanguage];

    window.cookieconsent.initialise({
      palette: {
        popup: {
          background: "#592d6f",
          text: "#ffffff",
        },
        button: {
          background: "#e64176",
          text: "#ffffff",
        },
      },
      theme: "classic",
      type: "opt-in",
      allowDecline: true,
      position: "bottom",
      content: {
        message: content.message,
        deny: content.deny,
        allow: content.allow,
        link: content.link,
        href: "/pdf/privacy-notice.pdf",
        policy: content.policy,
      },
    });

    window.setTimeout(function () {
      updateRevokeButton(content);
    }, 0);
  }

  function loadCookieConsentScript() {
    if (window.cookieconsent) {
      initialiseCookieConsent();
      return;
    }

    const existingScript = document.querySelector('script[src="' + cookieConsentScriptUrl + '"]');
    if (existingScript) {
      existingScript.addEventListener("load", initialiseCookieConsent);
      return;
    }

    const script = document.createElement("script");
    script.src = cookieConsentScriptUrl;
    script.async = true;
    script.addEventListener("load", initialiseCookieConsent);
    document.head.appendChild(script);
  }

  window.addEventListener("load", loadCookieConsentScript);
})();
